export const ABORT_CONTROLLER_SIGNAL_ABORTED_MESSAGE = 'AbortController.signal.aborted';
